import { Component, OnInit, Input } from '@angular/core';
import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-purchase-edit-info',
    templateUrl: './purchase-edit-info.component.html',
    styleUrls: ['./purchase-edit-info.component.scss'],
    standalone: false
})
export class PurchaseEditInfoComponent implements OnInit {

    @Input()
    public purchase: camps.OfficeCartPurchaseInfo;

    constructor() { }

    ngOnInit() {
    }

}
